import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

const BASE_URL = "http://localhost:3000";

function Secret() {
  const [response, setResponse] = useState<string>("");
  const [bytes, setBytes] = useState("");
  const [bytes2, setBytes2] = useState("");

  const makeRequest = async (method: string, endpoint: string, body?: any) => {
    try {
      const res = await fetch(`${BASE_URL}${endpoint}`, {
        method,
        headers: { "Content-Type": "application/json" },
        body: body ? JSON.stringify(body) : undefined,
      });
      const data = await res.json();
      setResponse(JSON.stringify(data, null, 2));
    } catch (error) {
      setResponse(`Error: ${error}`);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Secret API Interface</h1>
      <div className="mb-4">
        <h2 className="text-xl font-semibold">Health</h2>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/health")}
        >
          Get Health
        </button>
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-semibold">Inventory</h2>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/inventory")}
        >
          Get Inventory
        </button>
        <button
          className="bg-green-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/cashbox/reset", { place: "cashbox" })
          }
        >
          Reset Cashbox
        </button>
        <button
          className="bg-green-500 text-white px-4 py-2 rounded"
          onClick={() =>
            makeRequest("POST", "/inventory/set", {
              half: 10,
              one: 20,
              two: 30,
              five: 40,
              ten: 50,
              twenty: 60,
              fifty: 70,
              hundred: 80,
              two_hundred: 90,
            })
          }
        >
          Set Inventory
        </button>
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-semibold">Cash Payment</h2>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/cashpayment/sync")}
        >
          Get Unsynced Payments
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/cashpayment/progress")}
        >
          Get Payment Progress
        </button>
        <button
          className="bg-green-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/cash-payment/start", {
              transaction_id: "test-123",
              amount: 100,
              skip_change_payout: false,
              max_denomination: 50,
              min_denomination: 1,
            })
          }
        >
          Start Payment
        </button>
        <button
          className="bg-red-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("POST", "/cashpayment/test/abort")}
        >
          Abort Payment (test id)
        </button>
        <button
          className="bg-yellow-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/cashpayment/mock-input", {
              amount: 10,
              is_note: true,
            })
          }
        >
          Mock Input
        </button>
        <button
          className="bg-yellow-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/cashpayment/mock-error", {
              error: "test error",
            })
          }
        >
          Mock Error
        </button>
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("POST", "/cashpayment/finish-topup")}
        >
          Finish Topup
        </button>
        <button
          className="bg-orange-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("POST", "/cashpayment/disable/false")}
        >
          Disable Payment (false)
        </button>
        <button
          className="bg-orange-500 text-white px-4 py-2 rounded"
          onClick={() =>
            makeRequest("POST", "/cashpayment/cleanup", {
              payment_keys: ["1-test-123"],
            })
          }
        >
          Cleanup Payments
        </button>
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-semibold">Note Validator</h2>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("GET", "/note-validator/software-revision")
          }
        >
          Get software revision
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/status")}
        >
          Get Status
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("GET", "/note-validator/expanded-nv11-status")
          }
        >
          Get expanded Status
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/config")}
        >
          Get Config
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("GET", "/note-validator/currency-revision")
          }
        >
          Get Currency Revision
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/master-inhibit")}
        >
          Get Master Inhibit
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/cipher-key")}
        >
          Get Cipher Key
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/poll")}
        >
          Poll
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/poll-raw")}
        >
          Poll Raw
        </button>
        <button
          className="bg-green-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/note-validator/enable", {
              min_denomination: 1,
              max_denomination: 10000,
            })
          }
        >
          Enable
        </button>
        <button
          className="bg-red-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("POST", "/note-validator/disable")}
        >
          Disable
        </button>
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/note-validator/modify-operating-mode", {
              use_escrow: true,
            })
          }
        >
          Use escrow
        </button>
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/note-validator/modify-operating-mode", {
              use_escrow: false,
            })
          }
        >
          Don't use escrow
        </button>
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("PUT", "/note-validator/master-inhibit", {
              active: false,
            })
          }
        >
          Set Master Inhibit
        </button>
        <button
          className="bg-purple-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/note-validator/set-note-routes", {
              channels: Array(16).fill(true),
            })
          }
        >
          Set Note Routes
        </button>

        <button
          className="bg-purple-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("GET", "/note-validator/get-note-routes/1")
          }
        >
          Get Note Routes
        </button>
        <button
          className="bg-orange-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("POST", "/note-validator/dispense-latest")}
        >
          Dispense Latest
        </button>
        <button
          className="bg-orange-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("GET", "/note-validator/country-scaling/HU")
          }
        >
          Get Country Scaling (HU)
        </button>
        <button
          className="bg-orange-500 text-white px-4 py-2 rounded mr-2"
          onClick={() => makeRequest("GET", "/note-validator/bill-id/1")}
        >
          Get Bill ID (1)
        </button>
        <button
          onClick={() => makeRequest("POST", "/note-validator/enable-payout")}
        >
          Enable payout
        </button>
        <button
          className="bg-orange-500 text-white px-4 py-2 rounded mr-2"
          onClick={() =>
            makeRequest("POST", "/note-validator/command", {
              header: 4,
              data: [],
            })
          }
        >
          Send Command (Request Comms Revision)
        </button>
        <div>
          <input value={bytes} onChange={(e) => setBytes(e.target.value)} />

          <button
            className="bg-orange-500 text-white px-4 py-2 rounded"
            onClick={() => {
              const input = bytes.split(",").map(Number);
              const [lsb, msb] = calculatecrc16(input);
              return makeRequest("POST", "/note-validator/raw", {
                bytes: [input[0], input[1], lsb, ...input.slice(2), msb],
                // encryption_key: [1, 2, 3, 4, 5, 6],
                // encryption_key: [0, 0, 0, 0, 0, 0],
              });
            }}
          >
            Send Raw Bytes
          </button>
        </div>

        <div>
          <input value={bytes2} onChange={(e) => setBytes2(e.target.value)} />

          <button
            className="bg-orange-500 text-white px-4 py-2 rounded"
            onClick={() => {
              const input = bytes2.split(",").map(Number);
              return makeRequest("POST", "/note-validator/raw", {
                bytes: input,
                // encryption_key: [1, 2, 3, 4, 5, 6],
                // encryption_key: [0, 0, 0, 0, 0, 0],
              });
            }}
          >
            Send Raw Raw Bytes
          </button>
        </div>
      </div>

      <div className="mt-4">
        <h3 className="text-lg font-semibold">Response</h3>
        <pre className="bg-gray-100 p-2 rounded overflow-auto max-h-96">
          {response}
        </pre>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/secret" as any)({
  component: Secret,
});

function calculatecrc16(data: number[]) {
  // data is uint8array or array of bytes
  let crc = 0x0000;
  for (let byte of data) {
    crc ^= byte << 8;
    for (let i = 0; i < 8; i++) {
      if (crc & 0x8000) {
        crc = ((crc << 1) & 0xffff) ^ 0x1021; // poly
      } else {
        crc = (crc << 1) & 0xffff;
      }
    }
  }
  const lsb = crc & 0xff;
  const msb = (crc >> 8) & 0xff;
  return [lsb, msb]; // matches rust tuple order
}
